const AccordionTabHeader = ({ children, className = '' }) => {
  return <div className={`spo-m-accordion__header m-accordion__header ${className}`}>{children}</div>;
};

export default AccordionTabHeader;
